import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class DriverCredentialService {

  constructor(
    private http: HttpClient
  ) { }

  getDrivers(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.ALC_DRIVER_URL)
      .pipe(
        catchError(errorHandl)
      );
  }

  getDriverById(id: any): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.ALC_DRIVER_URL + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  saveDriver(payload: any, id?: any): Observable<any> {
    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.ALC_DRIVER_URL + '/' + id, payload)
      .pipe(
        catchError(errorHandl)
      );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.ALC_DRIVER_URL, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }
}
